export const DEFAULT_RECEIPT_SENDER_LIMIT = 500;
export const DEFAULT_EMAIL_ALIAS_LIMIT = 500;

export const DEFAULT_RECEIPTS_EMAIL = "receipts@kick.co";
export const RECEIPTS_EMAIL_DOMAIN = "receipts.kick.co";
export const BILLS_EMAIL_DOMAIN = "ap.kick.co";
export const INVOICES_EMAIL_DOMAIN = "ar.kick.co";
export const DEFAULT_RECEIPTS_PHONE_NUMBER = "+1 (628) 218-5115";

export const RESERVED_ENTITY_EMAIL_LOCAL_PARTS = [
    "abuse",
    "admin",
    "ap",
    "ar",
    "bills",
    "invoices",
    "noreply",
    "postmaster",
    "receipts",
    "support",
] as const;

export const WORKSPACE_EMAIL_ALIAS_KINDS = [
    "receipts",
    "bills",
    "invoices",
] as const;

export type WorkspaceEmailAliasKind =
    (typeof WORKSPACE_EMAIL_ALIAS_KINDS)[number];

export type DocumentForwardingIntent = "receipt" | "bill" | "invoice";

export const ALIAS_KIND_FORWARDING_INTENT: Record<
    WorkspaceEmailAliasKind,
    DocumentForwardingIntent
> = {
    receipts: "receipt",
    bills: "bill",
    invoices: "invoice",
};
